module.exports = __webpack_public_path__ + "static/assets/b00bfbb95d9fd659e13de786d4d36c94.svg";